import React, { useRef } from "react";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import get from "lodash/get";
import { withAnalytics } from "@redbubble/boom-analytics";
/* eslint-disable import/first */
import Box from "@redbubble/design-system/react/Box";
import Header from "@redbubble/design-system/react/Header";
import ProductNav from "../ProductNav";
import { MOBILE } from "@redbubble/design-system/react/constants";
import * as constants from "@redbubble/design-system/react/constants";
/* eslint-enable import/first */
import withUserInfo from "../../containers/apollo/withUserInfo";
import withBannerMessages from "../../containers/apollo/withBannerMessages";
import withUserAccount from "../../containers/apollo/withUserAccount";
import withCart from "../../containers/apollo/withCart";
import withReferer from "../../containers/redux/withReferer";
import withBrowserInfo from "../../containers/redux/withBrowserInfo";
import withSearch from "../../containers/redux/withSearch";
import { withPropsAndFragment as withProps } from "../../containers/wecompose";
import withGlobalNavigation from "../../containers/apollo/withGlobalNavigation";
import withLoginSignupModal from "../../containers/withLoginSignupModal";
import { useEngageTextMessaging } from "./useEngageTextMessaging";
import styles from "./Header.scss";
import { onSearchCallback, onTypaheadResultClick } from "../../lib/gtm/utils";
import {
  trackGA4GlobalNavViewCategory,
  trackGA4GlobalNavViewSubCategory,
} from "./analytics";
import { getInitialSeconds } from "./getCountdownSeconds";

const getPromoBannerHeight = (banners, profile) => {
  if (!banners || banners.length === 0) return 0;
  return profile === constants.DESKTOP ? 48 : 80;
};

const NO_BANNERS_WHITELIST = ["/shop/picks/"];

export const HeaderWithBanner = (props) => {
  const { banners, profile, ...rest } = props;

  const engagingPlaceholderMessages = useEngageTextMessaging();

  const isMobile = profile === MOBILE;
  const headerRef = useRef();
  const promoBannerHeight = getPromoBannerHeight(banners, profile);

  const initialSeconds = getInitialSeconds(banners);

  return (
    <React.Fragment>
      <Box className={styles.header} ref={headerRef}>
        <Header
          {...rest}
          profile={profile}
          useRainbowStyle
          engagingPlaceholderMessages={engagingPlaceholderMessages}
          showExpandedMobileSearch={isMobile}
          bannerMessages={banners}
          position="fixed"
          initialSeconds={initialSeconds}
          onSearchCallback={onSearchCallback}
          onTypaheadResultClick={onTypaheadResultClick}
          onNavItemClick={(item, rootItem) =>
            trackGA4GlobalNavViewSubCategory(item, {
              position: "left_side",
              parent: get(rootItem, "label"),
            })
          }
          onNavItemView={(item) =>
            trackGA4GlobalNavViewCategory(item, {
              position: "left_side",
            })
          }
          doSearch={false}
        />

        {profile === constants.DESKTOP && (
          <div data-product-nav data-testid="header-product-nav">
            <ProductNav
              peeking
              promoBannerHeight={promoBannerHeight}
              onNavItemClick={(item, rootItem) =>
                trackGA4GlobalNavViewSubCategory(item, {
                  position: "header",
                  parent: get(rootItem, "label"),
                })
              }
            />
          </div>
        )}
      </Box>
    </React.Fragment>
  );
};

const ComposedHeader = compose(
  injectIntl,
  withSearch,
  withRouter,
  withAnalytics,
  withUserInfo,
  withCart,
  withProps(({ userInfo, ...ownProps }) => ({
    ...ownProps,
    locale: userInfo.locale,
    countryCode: userInfo.country,
  })),
  withUserAccount,
  withReferer,
  withBrowserInfo,
  withBannerMessages,
  withLoginSignupModal,
  withProps(
    ({
      browser,
      profile,
      userInfo,
      messages,
      cart,
      busy,
      count,
      history,
      doSearch,
      parsedQuery,
      filter,
      productContext,
      openLoginSignupModal,
      ...ownProps
    }) => {
      const pathname = get(history, "location.pathname", "");
      const locale = get(userInfo, "locale");

      const banners = NO_BANNERS_WHITELIST.some((p) => pathname.includes(p))
        ? null
        : ownProps.banners;

      return {
        ...ownProps,
        cart: {
          ...cart,
          busy,
          itemsCount: count || get(cart, "totalItems"),
        },
        searchProductContext: productContext,
        doSearch: (newTerm, newProductContext) => {
          if (
            (!newProductContext && !productContext) ||
            (productContext && !newProductContext)
          ) {
            doSearch(history, newTerm);
          } else {
            doSearch(
              history,
              newTerm,
              parsedQuery,
              filter,
              locale,
              newProductContext || productContext
            );
          }
        },
        banners,
      };
    }
  ),
  withGlobalNavigation
)(HeaderWithBanner);

export default ComposedHeader;
